module.exports = __webpack_public_path__ + "static/media/bg-service-modulesC.e514fe43.png";